//import 'core-js';

require('element-closest');
require('intersection-observer');
